<template>
  <div class="invoice-dense-tab">
    <app-collapse class="mb-1 invoice-dense-filters">
      <app-collapse-item title="Filters">
        <template #header>
          <span class="invoice-dense-filters__title">
            <feather-icon icon="FilterIcon" size="15" />
            <span>Filters</span>
          </span>
        </template>
        <div class="p-2">
          <b-row>
            <b-col cols="12" sm="6" md="3">
              <b-form-group label="Start Date">
                <b-form-input v-model="filters.startDate" type="date" size="sm" />
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="3">
              <b-form-group label="End Date">
                <b-form-input v-model="filters.endDate" type="date" size="sm" />
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="3" class="d-flex align-items-end">
              <b-button variant="primary" size="sm" @click="$emit('apply', { ...filters })">Apply</b-button>
            </b-col>
          </b-row>
        </div>
      </app-collapse-item>
    </app-collapse>

    <div class="invoice-dense-toolbar">
      <div class="invoice-dense-toolbar__search">
        <b-input-group size="sm">
          <template #prepend>
            <b-input-group-text class="invoice-dense-search-icon">
              <feather-icon icon="SearchIcon" size="14" />
            </b-input-group-text>
          </template>
          <b-form-input v-model="search" placeholder="Search recruiter…" :debounce="200" />
          <template v-if="search" #append>
            <b-button size="sm" variant="outline-secondary" @click="search = ''">
              <feather-icon icon="XIcon" size="14" />
            </b-button>
          </template>
        </b-input-group>
      </div>
      <div class="invoice-dense-toolbar__meta">
        <span v-if="!loading">{{ filteredItems.length }} recruiter{{ filteredItems.length === 1 ? '' : 's' }}</span>
        <span v-else>Loading…</span>
      </div>
    </div>

    <div class="invoice-dense-table-wrap">
      <b-table
        :items="filteredItems"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        hover
        responsive
        :busy="loading"
        show-empty
        class="invoice-dense-table mb-0"
      >
        <template #table-busy>
          <div class="invoice-dense-state invoice-dense-state--loading">
            <b-spinner small class="mr-50" />
            <span>Loading recruiter data…</span>
          </div>
        </template>
        <template #empty>
          <div class="invoice-dense-state">
            <div class="invoice-dense-empty-icon">
              <feather-icon icon="UserIcon" size="28" />
            </div>
            <h6 class="mb-25">No recruiter data</h6>
            <p class="text-muted mb-1">
              {{ search ? 'Try a different search or clear filters.' : 'Apply date filters to load recruiter performance.' }}
            </p>
            <b-button v-if="search" size="sm" variant="outline-secondary" @click="search = ''">Clear search</b-button>
          </div>
        </template>
        <template #cell(recruiter_name)="{ item }">
          <b-link class="inv-invoice-link" @click="$emit('view-recruiter', item.recruiter_id)">{{ item.recruiter_name || 'N/A' }}</b-link>
        </template>
        <template #cell(revenue)="{ item }"><span class="inv-amount">₹{{ formatIndianNumber(item.revenue || 0) }}</span></template>
        <template #cell(placements_billed)="{ item }">{{ item.placements_billed || 0 }}</template>
        <template #cell(clients_count)="{ item }">{{ item.clients_count || 0 }}</template>
        <template #cell(avg_revenue_per_placement)="{ item }"><span class="inv-amount">₹{{ formatIndianNumber(item.avg_revenue_per_placement || 0) }}</span></template>
      </b-table>
    </div>

    <div v-if="filteredItems.length > perPage" class="invoice-dense-pagination">
      <b-pagination v-model="currentPage" :total-rows="filteredItems.length" :per-page="perPage" align="right" size="sm" class="mb-0" />
    </div>
  </div>
</template>

<script>
import { BRow, BCol, BFormGroup, BFormInput, BInputGroup, BInputGroupText, BTable, BButton, BLink, BSpinner, BPagination } from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import invoiceFormatMixin from '@/mixins/invoiceFormatMixin'

export default {
  name: 'RecruiterDashboardTab',
  components: { BRow, BCol, BFormGroup, BFormInput, BInputGroup, BInputGroupText, BTable, BButton, BLink, BSpinner, BPagination, AppCollapse, AppCollapseItem },
  mixins: [invoiceFormatMixin],
  props: {
    items: { type: Array, default: () => [] },
    fields: { type: Array, default: () => [] },
    loading: Boolean,
    perPage: { type: Number, default: 20 },
    initialFilters: {
      type: Object,
      default: () => ({ startDate: null, endDate: null })
    }
  },
  data() {
    return {
      search: '',
      currentPage: 1,
      filters: {
        startDate: this.initialFilters.startDate || null,
        endDate: this.initialFilters.endDate || null
      }
    }
  },
  computed: {
    filteredItems() {
      let data = [...this.items]
      if (this.search) {
        const q = this.search.toLowerCase()
        data = data.filter(i => (i.recruiter_name || '').toLowerCase().includes(q))
      }
      return data
    }
  },
  watch: {
    search() { this.currentPage = 1 },
    items() { this.currentPage = 1 }
  }
}
</script>

<style lang="scss">
@import './invoice-dense-tab.scss';
</style>
